import { Box, useTheme } from '@mui/material';
import { useContext, useEffect } from 'react';
import SiteLookupContext from '../context/SiteLookupContext';
import SiteLookupMapContext from '../context/SiteLookupMapContext';
import SiteLookupList from '../list/SiteLookupList';
import SiteLookupMap from '../map/SiteLookupMap';
import { siteLookupTokens } from '../siteLookupTokens';

const MainContent = () => {
  const { pendingRequest, result } = useContext(SiteLookupContext);
  const { isMapExtended, selectedSite, setSelectedSite } = useContext(SiteLookupMapContext);
  const { zIndex } = useTheme();

  const fetching = !!pendingRequest;
  const sites = result?.data.results;

  // A station that is still in the results keeps its selection and open sheet; an excluded one closes them.
  // biome-ignore lint/correctness/useExhaustiveDependencies: only when the results change
  useEffect(() => {
    if (selectedSite?.id && !sites?.some(({ id }) => id === selectedSite.id)) {
      setSelectedSite(null);
    }
  }, [sites]);

  return (
    <Box display="flex" height="100%" width="100%">
      <Box
        sx={{
          flexShrink: 0,
          zIndex: zIndex.mobileStepper,
          boxShadow: '0px 3px 3px rgb(0 0 0 / 12%)',
        }}
      >
        <Box
          // 380–460 px on desktop; the map takes the remaining width
          width={{ xs: 300, md: `clamp(${siteLookupTokens.size.listMinWidth}px, 32vw, ${siteLookupTokens.size.listMaxWidth}px)` }}
          sx={{
            display: isMapExtended ? 'none' : 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            paddingX: 2,
          }}
        >
          <SiteLookupList aggregateData={result?.data.aggregateData} fetching={fetching} hasSearchResult={!!result} sites={sites ?? []} />
        </Box>
      </Box>

      <Box
        sx={{
          flex: '1 1 auto',
          minWidth: 0,
          position: 'sticky',
          top: 'calc(var(--top-bar-height) + var(--site-lookup-header-height) + 1px)',
          height: 'calc(100vh - (var(--top-bar-height) + var(--site-lookup-header-height) + 1px))',
        }}
      >
        <SiteLookupMap fetchingSites={fetching} isReportCapped={!!result?.data.limitExceeded} sites={sites} />
      </Box>
    </Box>
  );
};

export default MainContent;
